import { createBrowserRouter } from 'react-router-dom';

import { AppLayout } from './AppLayout';
import { RechtstextSeite } from './RechtstextSeite';
import { AdminLayout } from './admin/AdminLayout';
import { AnmeldungSeite } from './admin/AnmeldungSeite';
import { BackupsSeite } from './admin/BackupsSeite';
import { ErgebnisseSeite } from './admin/ErgebnisseSeite';
import { ProtokollSeite } from './admin/ProtokollSeite';
import { SystemstatusSeite } from './admin/SystemstatusSeite';
import { TokenAusgabeSeite } from './admin/TokenAusgabeSeite';
import { TokensSeite } from './admin/TokensSeite';
import { DurchfuehrungSeite } from './admin/DurchfuehrungSeite';
import { UebersichtSeite } from './admin/UebersichtSeite';
import { VeranstaltungFormularSeite } from './admin/VeranstaltungFormularSeite';
import { VeranstaltungSeite } from './admin/VeranstaltungSeite';
import { VeranstaltungenSeite } from './admin/VeranstaltungenSeite';
import { AbstimmungSeite } from './admin/AbstimmungSeite';
import { AbstimmungFormularSeite } from './admin/AbstimmungFormularSeite';
import { AbstimmungenSeite } from './admin/AbstimmungenSeite';
import { AbstimmungenWeiche } from './admin/AbstimmungenWeiche';
import { PersonalisierungSeite } from './admin/PersonalisierungSeite';
import { EmailEinstellungenSeite } from './admin/EmailEinstellungenSeite';
import { TeilnehmerBereich } from './teilnehmer/TeilnehmerBereich';

/**
 * Router im Data Mode (§40.2).
 *
 * `/` ist der Teilnehmerbereich mit der öffentlichen Anmeldeseite nach §9.1, `/verwaltung` der
 * Administrationsbereich. Die Trennung der Zugänge erfolgt serverseitig über getrennte Sitzungen
 * und Cookies (§25.2) — diese Routen sind nur die Oberfläche dazu.
 *
 * Tokens und Abstimmungen liegen unterhalb ihrer Veranstaltung, weil sie ohne sie nicht bestehen
 * (§7.4: der Veranstaltungscode ist Bestandteil jedes Tokens; §10.2: die Nummerierung beginnt je
 * Veranstaltung bei 1). Die Einzelansicht einer Abstimmung liegt dagegen flach unter
 * `/verwaltung/abstimmungen/:id` — sie ist über ihre eigene Kennung eindeutig.
 *
 * Über allem liegt seit ÄA-2 eine **pfadlose** Layout-Route mit der gemeinsamen Fußzeile
 * ({@link AppLayout}). Sie ändert an den Pfaden nichts.
 */
export const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      {
        path: '/',
        element: <TeilnehmerBereich />,
      },
      {
        path: '/verwaltung',
        element: <AnmeldungSeite />,
      },
      // Impressum und Datenschutz sind ohne Anmeldung erreichbar (ÄA-5). Die Fußzeile öffnet sie
      // in einem neuen Tab, damit ein Klick keine laufende Abstimmung verlässt (§19.1).
      { path: '/impressum', element: <RechtstextSeite art="impressum" /> },
      { path: '/datenschutz', element: <RechtstextSeite art="datenschutz" /> },
      {
        path: '/verwaltung',
        element: <AdminLayout />,
        children: [
          { path: 'uebersicht', element: <UebersichtSeite /> },
          { path: 'durchfuehrung', element: <DurchfuehrungSeite /> },
          { path: 'veranstaltungen', element: <VeranstaltungenSeite /> },
          { path: 'veranstaltungen/neu', element: <VeranstaltungFormularSeite /> },
          { path: 'veranstaltungen/:id', element: <VeranstaltungSeite /> },
          { path: 'veranstaltungen/:id/bearbeiten', element: <VeranstaltungFormularSeite /> },
          { path: 'veranstaltungen/:id/tokens', element: <TokensSeite /> },
          { path: 'veranstaltungen/:id/tokens/ausgabe', element: <TokenAusgabeSeite /> },
          { path: 'veranstaltungen/:id/abstimmungen', element: <AbstimmungenSeite /> },
          {
            // Eigener Parametername, weil dieselbe Formularseite im Bearbeitungsfall die Kennung der
            // **Abstimmung** erhält. Zwei Bedeutungen unter einem Namen wären eine Fehlerquelle.
            path: 'veranstaltungen/:veranstaltungId/abstimmungen/neu',
            element: <AbstimmungFormularSeite />,
          },
          { path: 'abstimmungen', element: <AbstimmungenWeiche /> },
          { path: 'abstimmungen/:id', element: <AbstimmungSeite /> },
          { path: 'abstimmungen/:id/bearbeiten', element: <AbstimmungFormularSeite /> },
          { path: 'ergebnisse', element: <ErgebnisseSeite /> },
          { path: 'backups', element: <BackupsSeite /> },
          { path: 'protokoll', element: <ProtokollSeite /> },
          { path: 'systemstatus', element: <SystemstatusSeite /> },
          { path: 'personalisierung', element: <PersonalisierungSeite /> },
          { path: 'email-versand', element: <EmailEinstellungenSeite /> },
        ],
      },
      {
        // Rückfall der Einzelseitenanwendung. Führt in den Teilnehmerbereich und damit — ohne
        // Sitzung — auf die Anmeldeseite, die nach §9.1 nichts preisgibt.
        path: '*',
        element: <TeilnehmerBereich />,
      },
    ],
  },
]);
